module.exports = __webpack_public_path__ + "img/materials-2_en.94dfe93.jpg";